// Fleet Management

$('.fig-arrow').on('click', function() {
  $('.fig-icon-nav').toggleClass('active');
});

$('.fig-indiv-nav-item').on('click', function(){
  $('.fig-indiv-nav-item').removeClass('active');
  $(this).addClass('active');
  
  var currentImg = $(this).attr('data-laptop');
  $('.fig-laptop').attr('src', currentImg);
});



// SLICK SLIDER FOR HOME PARTNERS

$('document').ready(function(){
  
  $('.partner-slider-wrap').slick({
    infinite: true,
    // the magic
  responsive: [{

      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        infinite: true,
        rows: 3,
        dots: true
      }

    }, {

      breakpoint: 3000000,
      settings: "unslick" // destroys slick

    }]
  });

  
//   FIG TESTIMONIALS
  
  $('.fig-testimonials').slick({
    infinite: true,
    centerMode: true,
    slidesToShow: 1,
    variableWidth: true,
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 5000
  });
  
  //   Hero Video Slider
  $('.fig-hero-video-slider-wrap').slick({
    infinite: true,
    arrows: true,
    dots: true,
    autoplay: true,
    autoplaySpeed: 6000
  });
  
//   $('.fig-hero-video-slider-wrap').on('setPosition', function () {
//     $(this).find('.slick-slide').height('auto');
//     var slickTrack = $(this).find('.slick-active .fig-hero-video-slide');
//     var slickTrackHeight = $(slickTrack).outerHeight();
//     $(this).find('.slick-slide').css('height', slickTrackHeight + 'px');
//   });
  
});


// fig functions

function addCustomEvent(element, eventType, eventFunction) {
    if( element ) {
      element.addEventListener(eventType, eventFunction);
    }
  }

  function addLoopedFunction(elements, eventTypes, eventFunctions) {
    if ( elements ) {
      elements.forEach(element => {
        element.addEventListener(eventTypes, eventFunctions);
      });
    }
  }

  function addLoopedEscape(activeElements) {
    if ( activeElements ) {
      activeElements.forEach(element => {
        element.classList.remove('active');
      });
    }
  }


// MODAL VIDEO
$('document').ready(function(){

  addLoopedFunction( document.querySelectorAll('.play-video'), 'click', (e) => {
    e.preventDefault();
    let videoSource = e.target.getAttribute('data-video-source');
    let videoEmbed, focusedElementBeforeTarget;

    focusedElementBeforeTarget = e.target;
    document.querySelector('.modal-con').classList.add('active');
    document.querySelector('.embed-container').innerHTML = '';

    if( videoSource.includes('youtu') ) {
      let ytRegExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/,
            match = videoSource.match(ytRegExp),
            src = match[2],
            videoEmbed = 'https://youtube.com/embed/' + src;
            addVideoToModal(videoEmbed);
    } else if ( videoSource.includes('vimeo') ) {
      let vimeoRegExp = /http(s)?:\/\/(www\.)?vimeo.com\/(\d+)(\/)?(#.*)?/,
            match = videoSource.match(vimeoRegExp),
            src = match[3],
            videoEmbed = 'https://player.vimeo.com/video/' + src;
            addVideoToModal(videoEmbed);
    }

    window.addEventListener("keydown", function(event) {
      if ( event.keyCode === 27 ) {
        document.querySelector('.modal-con').classList.remove('active');
        document.querySelector('.embed-container').innerHTML = '';
        focusedElementBeforeTarget.focus();
      }
    });

  });
  
  addCustomEvent( document.querySelector('.modal-con'), 'click', () => {
    document.querySelector('.modal-con').classList.remove('active');
    document.querySelector('.embed-container').innerHTML = '';
  });

// Product Selection

addLoopedFunction( document.querySelectorAll('.product-gallery-con'), 'click', (e) => {
  console.log('clicked');
  document.querySelectorAll('.product-gallery-con').forEach((thumbItem) => {
     thumbItem.classList.remove('active');
  });
   console.log(e.target.getAttribute('data-src'));
  var thumbnailImageUrl;
  
  
  
  if( !e.target.classList.contains('product-gallery-con') ) {
    e.target.closest('.product-gallery-con').classList.add('active');
    thumbnailImageUrl = e.target.getAttribute('data-src');
  } else {
    
    e.target.classList.add('active');
    thumbnailImageUrl = e.target.closest('.product-thumb').getAttribute('data-src');
    
  }
  document.querySelector('#product-featured img').setAttribute("src", thumbnailImageUrl);
  	
  });


// 	siren pro tabs

  addLoopedFunction( document.querySelectorAll('h3[data-open-tab]'), 'click', (e) => {
	console.log('clicked');
    let thisTab = e.target.getAttribute('data-open-tab');
    
    document.querySelectorAll('[data-opened-tab]').forEach((openedTab) => {
       openedTab.classList.remove('active');                                                   
     });
    
    document.querySelectorAll('[data-open-tab]').forEach((openTab) => {
       openTab.classList.remove('active');                                                   
     });
    
    document.querySelector(`[data-open-tab="${thisTab}"]`).classList.add('active');
    document.querySelector(`[data-opened-tab="${thisTab}"]`).classList.add('active');
    
  });

  
});


function addVideoToModal(videoEmbed) {
  document.querySelector('.embed-container').innerHTML = '<iframe allow="autoplay" title="video pop out" src="' + videoEmbed + '?rel=0&title=0&autoplay=1&byline=0&enablejsapi=1"  frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
}


